module.exports = __webpack_public_path__ + "static/media/36.2ec81353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/36.jpg
// module id = 597
// module chunks = 0